<script>
import resources from './resources'

export default {
  name: 'dependent_form',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(icon="", title="Meus Dependentes")
    .col-xs-12.content
      .container-fluid
        .row
          .col-xs-12.white-bg
            .row
              .col-xs-12
                form.col-sm-10
                  .cadastro-form
                    .row
                      .col-xs-12.col-sm-6
                        v-input(:status="$v.dependent.name.$error ? 'error' : null")
                          v-text(
                            label="Nome Completo",
                            id="name",
                            v-model="dependent.name",
                            name="name",
                            autocomplete="off",
                            :status="$v.dependent.name.$error ? 'error' : null",
                            @blur="$v.email.$touch()")

                      .col-xs-12.col-sm-3.margin-bottom
                        v-input(:status="$v.dependent.birthdate.$error ? 'error' : null")
                            label(v-if="!$v.dependent.birthdate.$error") Data de nascimento
                            label(style="color: #a94442;", v-if="$v.dependent.birthdate.$error") Data de nascimento
                            .input-group
                              v-datepicker(
                                v-model='dependent.birthdate',
                                name="birthdate"
                                :config='config')
                            //-f-date(
                              label="Data de nascimento",
                              v-model="dependent.birthdate",
                              :errors="errors['birthdate']")

                      .col-xs-12.col-sm-3
                        v-input(:status="$v.dependent.kinship_id.$error ? 'error' : null")
                          f-select-kinship(
                            label="Grau de Parentesco",
                            :get-all="true",
                            name="degree",
                            v-model="dependent.kinship_id",
                            label-by="name",
                            :searchable="false",
                            :errors="errors['kinship_id']")

                  .form-group
                    .row
                      .col-xs-12.col-sm-6
                        f-email(
                          v-model="dependent.email",
                          label="E-mail",
                          name="email",
                          :errors="errors['email']")

                      .form-group.col-xs-12.col-sm-3.margin-bottom
                        label Telefone Fixo
                        f-phone(
                          :force-label="true",
                          :current="dependent.phone",v-model="dependent.phone", label="Telefone Fixo", name="phone",
                          :errors="errors['phone']")

                      .form-group.col-xs-12.col-sm-3.margin-bottom
                        label Telefone Celular
                        f-phone(
                          :force-label="true",
                          :current="dependent.mobile",
                          :value="dependent.mobile",
                          v-model="dependent.mobile",
                          label="Telefone Celular",
                          name="mobile",
                          :errors="errors['mobile']")

                  .buttons-wrapper
                    button.btn.cancel
                      router-link(:to="{ name: 'settings.dependents.index'}")
                        span.icon 
                        |  Cancelar
                    button.btn.save(@click.prevent="doSave()", v-if="!isEdited && !dependent.id")
                      span.icon 
                      |  Salvar {{ dependent.id }}

                    button.btn.save(@click.prevent="doSave()", v-if="isEdited || dependent.id")
                      span.icon 
                      |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/settings/dependents/form/form.vue